<template>
  <div>
    <div class="product_video" v-if="intro">
      <h4>产品简介</h4>
      <div class="vHtmlMess" v-html="productInfo.detail"></div>
    </div>
    <div class="product_video">
      <h4  v-if="intro">产品视频</h4>
      <div class="product_video_box">
        <div class="list-vedio" v-for="(item, index) in productInfo.videoList" :key="index">
          <video-player
              class="video-player vjs-custom-skin my-video"
              ref="videoPlayer"
              :playsinline="true"
              style="height: 171px; width: 304px; margin-right: 22px"
              :options="playerOptions[index]"
          >
          </video-player>
          <div class="video_zz" @click="onClickVideo(item.url)"></div>
        </div>
        <div style="width: 100%; text-align: center;">
         <el-empty  v-if="productInfo.videoList.length==0" description="暂无数据" :image-size="100"></el-empty>
        </div>
      </div>
    </div>
    <!-- 点击查看视频 -->
    <VideoDialog ref="videoDialogRef" />
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import VideoDialog from "../../VideoDialog/index.vue";
export default {
  props:{
    productInfo:Object,
     intro: {
      type: Boolean,
      default: true,
    }
  },
  components: {
    videoPlayer,
    VideoDialog
  },
  data() {
    return {
      playerOptions: [],
    };
  },
  created() {
  },
  watch: {
    productInfo: {
      handler(val) {
        this.getVideoData(val)
      },
      immediate: true,
      deep:true
    },
  },
  methods: {
    getVideoData(val) {
      // 把后台数据给到reply
      // this.reply = resxxxx
      for(let i of  val.videoList) {
        let playrOptionsList = {
          autoplay: false, //如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: "zh-CN",
          aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          // fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [
            {
              type: "video/mp4",
              src: i.url, //你的视频地址（必填）
            },
          ],
          poster: "", //你的封面地址
          width: document.documentElement.clientWidth,
          notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: false,
            durationDisplay: false,
            remainingTimeDisplay: false,
            fullscreenToggle: true, //全屏按钮
          }
        }
        this.playerOptions.push(playrOptionsList)
      }
    },
    // 点击查看视频
    onClickVideo(url) {
      this.$refs.videoDialogRef.init(url)
    },
  }
};
</script>

<style lang="less" scoped>
img {
  width: 140px;
  height: 100px;
}
.csbox {
  display: flex;
  flex-wrap: wrap;
  p {
    width: 50%;
  }
}
.czbox {
  display: flex;
  justify-content: space-around;
  p {
    color: #099;
    cursor: pointer;
  }
}
.product_video {
  margin: 21px 35px 40px;
  h4 {
    margin-bottom: 29px;
  }
  .product_video_box {
    display: flex;
  }
  /deep/.my-video {
    .vjs-poster {
      background-size: 100% 100%;
    }
  }
}
.list-vedio {
  position: relative;
  .video_zz {
    position: absolute;
    top: 0;
    height: 171px;
    width: 304px;
    background: transparent;
    border-radius: 8px;
    cursor: pointer;
  }
}
/deep/.video-js,/deep/.vjs-tech {
  border-radius: 8px;
}
/deep/.vjs-custom-skin > .video-js .vjs-big-play-button {
    width: 40px !important;
    height: 40px !important;
    border-radius: 50%;
    line-height: 40px !important;
    transform: translate(-50%, -50%);
    margin: 0 !important;
    border: none;
}

</style>



// WEBPACK FOOTER //
// src/components/product/components/productComDetails.vue